import { useSelector } from 'react-redux';
import { equals } from 'lodash/fp';

import store, { reducer } from '.';

type RootState = ReturnType<typeof reducer>;
type Selector<T, R = any> = (state: T) => R;

/**
  * Bread and butter of the state management system. Redux acts as the bridge
* between jQuery and React so we need a way to react to changes in jQuery. This
* subscribeOn function allows you to select changes in jQuery and set local
* state
*/
export function subscribeOn<R = any>(selector: Selector<RootState, R>, listener: (value: R) => void) {
  let previousValue;

  function subscribedSelector() {
    const currentValue = selector(store.getState());

    if (!equals(previousValue)(currentValue)) {
      listener(currentValue);
      previousValue = currentValue;
    }
  }

  return store.subscribe(subscribedSelector);
}

export function useStateBus<R>(selector: Selector<RootState, R>): R {
  return useSelector(selector);
}
